<template>
    <div class="singlePage">
        <div class="header">
            <div class="head clearfix">
                <h1 class="logo">
                    <a href="javascript:;" @click="goHomePage()" title="琅琊天楹">
                        <span>琅琊天楹</span>
                        <a href="http://www.aiyechen.com" target="_blank" title="野尘出品" class="ycCopyright">➲ 野尘出品</a>
                    </a>
                </h1>
                <div class="enterprise" @click="goPersonalInfo()">
                    <span class="userNam" >{{userInfo&&userInfo.userName}}</span>
                    <span class="company" >{{userInfo&&userInfo.companyName}}</span>
                </div>
            </div>
        </div>

        <div class="content">
            <div class="promptImg"></div>
            <h3 class="titleContent">抱歉，此页面无法访问...</h3>
            <a href="javascript:;" @click="goHomePage()" class="returnHome" title="返回首页">返回首页</a>
        </div>
    </div>
</template>

<script>
    import {mapState} from 'vuex'
    import ProductAlter from '../components/productAlter.vue'
    import CompanyList from '../components/companyList.vue'
    import CompanyOutlook from '../components/companyOutlook.vue'
    import ProductList from '../components/productList.vue'
    import { error } from 'util'
    import ssUtil from '@/utils/SStorage'
    import $ from 'jquery'
    import { setTimeout } from 'timers';

    export default {
        name: 'dashBoard',
        data() {
            return {
                isFlag:false,           //请求数据是否结束
                isSearchEnd:false,      //是否搜索结束
                isSelPro:'company',     //是否选择了公司/产品选项
                searchKey:'',           //关键词搜索
                activeName: 'first',    //底部详细图片选择的那个Tab
            }
        },
        components:{ProductAlter,CompanyList,CompanyOutlook,ProductList},
        computed:{...mapState(['isLogin','userInfo','indexSearchInfo','proPageSearchParams'])},
        created(){
            this.$store.dispatch('setLoginState', ssUtil.getItem('isLogin'))
            this.$store.dispatch('userInfo', ssUtil.getItem('userInfo'))
            if( this.proPageSearchParams.flag &&this.proPageSearchParams.flag == 'productInfo'){
                this.isSelPro = this.proPageSearchParams.searchTab
                this.isSearchEnd = true;
                this.searchKey = this.proPageSearchParams.searchKey;
                this.activeName =  'three'
            }
        },
        methods: {
            //返回首页
            goHomePage(){
                this.$router.push({
                    path:'/dashBoard'
                })
            },
            //进入个人中心或者登录页
            goPersonalInfo(){
                if( this.isLogin ){
                    //个人中心
                    this.$router.push({
                        path:'/personal'
                    })
                }else{
                    //登录页面
                    this.$router.push({
                        path:'/login'
                    })
                }
            }
        }
    }
</script>

<style lang="scss" src="../sass/promptPage.scss" ></style>



// WEBPACK FOOTER //
// src/view/promptPage.vue